/**
 * The 13 languages of an employee's translatable metadata in the users service
 * (users-lib EmployeeMetadata). Note `ua`, not `uk`, and `jp`, not `ja` — the service's codes.
 * EN first: it is the one the others are usually translated from.
 */
export const EMPLOYEE_LANGUAGES = ["en", "ru", "ua", "ar", "de", "es", "fr", "it", "pl", "pt", "kz", "id", "jp"];

export const emptyTranslations = () =>
  EMPLOYEE_LANGUAGES.reduce((translations, lang) => ({ ...translations, [lang]: "" }), {});

/** A translations object with every language present (missing ones as ""), unknown keys dropped. */
export const normaliseTranslations = (value) =>
  EMPLOYEE_LANGUAGES.reduce(
    (translations, lang) => ({ ...translations, [lang]: (value && value[lang]) || "" }),
    {}
  );
